import { Rating } from '@/domains/core/tamagoshiTailwind/components/Rating/Rating';
import { SectionButton } from '@/domains/core/tamagoshiTailwind/components/SectionButton/SectionButton';
import { rating } from '@/domains/core/tamagoshiTailwind/translations';
import { useReviewsStats } from '@/domains/productDiscovery/ArticleReviews/ReviewsStats.ducks';
import { customerReviews } from '@/domains/productDiscovery/ArticleReviews/translations';
import { descriptionPanelTitle } from '@/domains/productDiscovery/ProductPage/common/components/SidePanelContainer/SidePanelContainer';
import { DeliverySectionButton } from '@/domains/productDiscovery/ProductPage/common/modules/Delivery/DeliverySectionButton';
import { concreteGuaranteeLabel } from '@/domains/productDiscovery/ProductPage/common/modules/GoodToKnow/translations';
import { useSidePanel } from '@/domains/productDiscovery/ProductPage/hooks/useSidePanel';
import { Advantages } from '@/productDiscovery/ProductPage/common/components/Advantages/Advantages';

export const SectionButtons = () => {
  const { goToDescription, goToReview, goToConcreteGuarantee } = useSidePanel();
  const reviews = useReviewsStats();

  return (
    <div>
      <div className="desktop:px-m">
        <DeliverySectionButton />

        <SectionButton
          title={descriptionPanelTitle}
          hoverDisabled
          onClick={goToDescription}
          compact
          variant="L"
        />

        <SectionButton
          title={customerReviews}
          hoverDisabled
          endAddon={
            reviews.total > 0 && (
              <Rating
                aria-label={rating.ariaLabel}
                reviewsCount={reviews.total}
                size="S"
                value={reviews.average}
              />
            )
          }
          compact
          onClick={goToReview}
          variant="L"
        />
      </div>

      <Advantages />

      <div className="desktop:px-m">
        <SectionButton
          title={concreteGuaranteeLabel}
          hoverDisabled
          compact
          onClick={goToConcreteGuarantee}
          variant="L"
        />
      </div>
    </div>
  );
};
